import { LOCALE_ID, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SmartparkingHomeComponent } from './smartparking-home/smartparking-home.component';
import { SmartparkingDashboardComponent } from './smartparking-dashboard/smartparking-dashboard.component';
import { AppRoutingModule } from 'app/app-routing.module';
import { MaterialModule } from 'app/shared/material/material.module';
import { SmartparkingCameraInfosLastSyncComponent } from './smartparking-camera-infos-last-sync/smartparking-camera-infos-last-sync.component';
import { CarSuctionCupComponent } from './smartparking-dashboard/car-suction-cup/car-suction-cup.component';
import { OccupancyRateComponent } from './smartparking-dashboard/occupancy-rate/occupancy-rate.component';
import { ChartComponent } from './smartparking-dashboard/chart/chart.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ChartsModule } from 'ng2-charts';
import { SmartparkingSlotsComponent } from './smartparking-slots/smartparking-slots.component';
import { SmartparkingSlotsTableComponent } from './smartparking-slots-table/smartparking-slots-table.component';
import { SmartparkingCamerasComponent } from './smartparking-cameras/smartparking-cameras.component';
import { SmartparkingCamerasUpdateComponent } from './smartparking-cameras-update/smartparking-cameras-update.component';
import { SmartparkingCamerasAddComponent } from './smartparking-cameras-add/smartparking-cameras-add.component';
import { SmartparkingSlotsAddComponent } from './smartparking-slots-add/smartparking-slots-add.component';
import { SmartparkingCamerasConfigComponent } from './smartparking-cameras-config/smartparking-cameras-config.component';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { HttpClient } from '@angular/common/http';
import { TranslateModule, TranslateLoader, MissingTranslationHandler } from '@ngx-translate/core';
import { appInitializerProviders } from 'app/shared/apiInitializerProviders';
import { ApiMissingTranslationHandler } from 'app/shared/apiMissingTranslationHandler';
import { ApiTranslateLoader } from 'app/shared/apiTranslationLoader';
import { httpInterceptorProviders } from 'app/shared/http-interceptors';
import { OpendialogOverviewParkComponent } from './smartparking-dialog/opendialog-overview-park/opendialog-overview-park.component';

registerLocaleData(localeFr, 'fr');

export function TranslateLoaderFactory(http: HttpClient): ApiTranslateLoader {
  return new ApiTranslateLoader(http);
}

@NgModule({
  declarations: [
    SmartparkingHomeComponent,
    SmartparkingDashboardComponent,
    SmartparkingCameraInfosLastSyncComponent,
    CarSuctionCupComponent,
    OccupancyRateComponent,
    ChartComponent,
    SmartparkingSlotsComponent,
    SmartparkingSlotsTableComponent,
    SmartparkingCamerasComponent,
    SmartparkingCamerasUpdateComponent,
    SmartparkingCamerasAddComponent,
    SmartparkingSlotsAddComponent,
    SmartparkingCamerasConfigComponent,
    OpendialogOverviewParkComponent,
  ],
  imports: [
    CommonModule,
    AppRoutingModule,
    MaterialModule,
    FontAwesomeModule,
    FormsModule,
    ReactiveFormsModule,
    ChartsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: TranslateLoaderFactory,
        deps: [HttpClient]
      },
      missingTranslationHandler: {
        provide: MissingTranslationHandler,
        useClass: ApiMissingTranslationHandler
      }
    })

  ],
  exports: [
    SmartparkingHomeComponent,
    SmartparkingDashboardComponent,
    SmartparkingCameraInfosLastSyncComponent,
    CarSuctionCupComponent,
    OccupancyRateComponent,
    ChartComponent,
    SmartparkingSlotsComponent,
    SmartparkingSlotsTableComponent,
    SmartparkingCamerasComponent,
    SmartparkingCamerasUpdateComponent,
    SmartparkingCamerasAddComponent,
    SmartparkingSlotsAddComponent,
    SmartparkingCamerasConfigComponent

  ],
  providers: [
    appInitializerProviders,
    httpInterceptorProviders,
    { provide: LOCALE_ID, useValue: 'fr' },


  ]
})
export class SmartparkingModule { }
